import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { TenantService } from '../services/tenant.service';

@Injectable({
  providedIn: 'root'
})
export class PigeonholeEnabledGuard implements CanActivate {

  constructor(private tenantService: TenantService, private router: Router) { }

  async canActivate(): Promise<boolean> {
    const tenant = await this.tenantService.get();
    if (tenant && tenant.enablePigeonhole) {
      return true;
    }
    await this.router.navigate(['/dashboard']);
    return false;
  }
}
